import { ProfileAPIService } from '../../services/AxiosAPIService';

export const recordLogin = async (): Promise<void> => {
  await ProfileAPIService.api.post('/me/login');
};
